import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES } from '../../../../shared/supported-locales.js';

const LANGS = SUPPORTED_LOCALES;

/**
 * Language switcher backed by a native <select>. Unlike the Combobox's text
 * input, tapping the native select opens the OS picker on touch — no text
 * caret, no software keyboard, and no dropdown placement concerns near the
 * viewport edge — while keeping full keyboard accessibility.
 *
 * @param {Object} props
 * @param {string} [props.id]
 * @param {string} props.value
 * @param {(value: string) => void} props.onChange
 * @param {string} [props.ariaLabel]
 * @param {string} [props.className]
 * @returns {JSX.Element}
 */
export function LanguageSelect({ id, value, onChange, ariaLabel, className }) {
	const { t } = useTranslation();
	const clsx = className ? ' ' + className : '';
	return (
		<div className={`language-select${clsx}`}>
			<select
				id={id}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				aria-label={ariaLabel}
				className="text-field"
			>
				{LANGS.map((lang) => (
					<option key={lang} value={lang}>
						{t(`language.${lang}`)}
					</option>
				))}
			</select>
			<span className="combobox-chevron" aria-hidden="true">
				<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
					<polyline points="6 9 12 15 18 9" />
				</svg>
			</span>
		</div>
	);
}
